import axios from "axios";
import firebase from "firebase";
import config from "../config";

const API = axios.create({
  responseType: "json",
  baseURL: config.ApiUrl,
});

API.interceptors.request.use(async (request) => {
  const token = localStorage.getItem("token");
  request.headers = {
    Authorization: `Bearer ${token}`,
  };
  return request;
});

API.interceptors.response.use(
  (response) => {
    return response.data.resultObject;
  },
  (error) => {
    // Network error / CORS / timeout: there is no response object at all.
    if (!error.response) {
      const msg = `Netzwerkfehler: ${error.message}`;
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "error", stage: "network", message: msg })
        );
      }
      return Promise.reject(error);
    }

    const status = error.response.status;
    const errors = error.response.data;

    // Surface the failure to the native app instead of silently swallowing it.
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "error",
          stage: "api",
          status,
          url: error.config?.url,
          message:
            (errors && (errors.message || JSON.stringify(errors))) ||
            `HTTP ${status}`,
        })
      );
    }

    // Reject so react-query onError actually fires (previously 401 returned
    // undefined and the caller thought it "succeeded").
    return Promise.reject(error);
  }
);

export default API;
